<div class="alerts-container">
    <div class="alerts-content">
        <div class="alerts-table-wrapper">
            <table class="alerts-table">
                <thead>
                    <tr>
                        <th>#</th>
                        <th>Alarm Type</th>
                        <th>Timestamp</th>
                        <th>Status</th>
                    </tr>
                </thead>
                <tbody>
                    <!-- Loading State -->
                    <tr *ngIf="isLoading" class="loading-row">
                        <td colspan="4" class="loading-cell">
                            <div class="loading-state">
                                <div class="spinner"></div>
                                <p>Loading alarms...</p>
                            </div>
                        </td>
                    </tr>

                    <!-- Alert Rows -->
                    <tr *ngFor="let alert of alerts; let i = index" class="alert-row"
                        [class.alert-critical]="alert.status === 'critical'"
                        [class.alert-warning]="alert.status === 'warning'">
                        <td>{{ i + 1 }}</td>
                        <td>{{BHEL_ON_PREM?"Vibration anomaly detected. Please review":alert.type }}</td>
                        <td>{{ alert.timestamp }}</td>
                        <td>
                            <span class="status-badge" [class.status-critical]="alert.status === 'critical'"
                                [class.status-warning]="alert.status === 'warning'"
                                [class.status-resolved]="alert.status === 'resolved'">
                                {{ alert.status | titlecase }}
                            </span>
                        </td>
                    </tr>

                    <!-- No Alerts State (only shown when loading is complete and no alerts) -->
                    <tr *ngIf="!isLoading && alerts.length === 0" class="no-alerts-row">
                        <td colspan="4" class="no-alerts-cell">
                            <div class="no-alerts">
                                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                    stroke-width="2">
                                    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                                    <polyline points="22 4 12 14.01 9 11.01"></polyline>
                                </svg>
                                <p>No alarms in the last 12 hours</p>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>